module.exports = __webpack_public_path__ + "static/media/Facebook.85d2b069.svg";